import { Injectable } from '@angular/core';
import { TranslateParser, TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { OLD_TRANSLATIONS_PREFIX } from '../utils/old-translation-handler';

@Injectable({
  providedIn: 'root'
})
export class MultiLanguageTranslateService {
  constructor(
    private translate: TranslateService,
    private parser: TranslateParser
  ) {}

  public get(
    language: string,
    key: string,
    interpolateParams?: unknown
  ): Observable<string | undefined> {
    return this.translate.getTranslation(language).pipe(
      map(translationData => {
        // like OldTranslationHandler: fall back to the old bundle on a miss
        const translation =
          this.parser.getValue(translationData, key) ??
          this.parser.getValue(
            translationData,
            `${OLD_TRANSLATIONS_PREFIX}.${key}`
          );

        return this.parser.interpolate(translation, interpolateParams);
      })
    );
  }
}
